import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { api } from '@/lib/api';

export default function Malls() {
    const [malls, setMalls] = useState([]);

    useEffect(() => { api.get('/malls').then(({ data }) => setMalls(data)); }, []);

    return (
        <div data-testid="malls-page" className="pt-16">
            <section className="max-w-7xl mx-auto px-6 md:px-12 pt-12 pb-20">
                <div className="overline mb-6">Our Network</div>
                <h1 className="font-serif text-6xl md:text-7xl text-navy leading-[1.02] tracking-tight max-w-4xl">
                    Six Inorbit malls.<br /><span className="italic text-gold">Built for the moments that matter.</span>
                </h1>
                <p className="max-w-2xl mt-10 text-text-secondary text-lg leading-relaxed">
                    From Mumbai's pioneer destination to Andhra Pradesh's largest mega centre — every Inorbit mall is built to inspire discovery, drive engagement and elevate every experience.
                </p>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-8 pb-32">
                {malls.map((m, i) => (
                    <Link key={m.id} to={`/mall/${m.slug}`} className="card-luxury group block img-zoom" data-testid={`mall-list-${m.slug}`}>
                        <div className="aspect-[16/10] overflow-hidden relative">
                            <img src={m.hero_image} alt={m.name} className="w-full h-full object-cover" />
                            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-8 text-white">
                                <div className="overline text-gold mb-2">No. {String(i + 1).padStart(2, '0')}</div>
                                <div className="font-serif text-3xl">{m.name}</div>
                            </div>
                        </div>
                        <div className="p-8">
                            <div className="text-sm text-gold italic mb-4">{m.tagline}</div>
                            <p className="text-sm text-text-secondary leading-relaxed line-clamp-3">{m.description}</p>
                            <div className="mt-6 flex items-center justify-between border-t border-border-subtle pt-5">
                                <div className="flex items-center gap-2 text-xs text-text-tertiary uppercase tracking-widest">
                                    <MapPin size={12} strokeWidth={1.5} /> {m.city}, {m.state}
                                </div>
                                <div className="text-xs text-navy uppercase tracking-widest group-hover:text-gold flex items-center gap-2">
                                    {m.brand_count}+ Brands <ArrowRight size={14} strokeWidth={1.5} />
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </section>
        </div>
    );
}
